import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('[ErrorBoundary] caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '2rem',
          fontFamily: 'monospace',
          background: '#fff1f1',
          border: '2px solid #ef4444',
          borderRadius: '12px',
          margin: '2rem',
          maxWidth: '900px',
        }}>
          <h2 style={{ color: '#dc2626', marginBottom: '0.5rem' }}>
            ⚠️ Something went wrong rendering this page.
          </h2>
          <p style={{ color: '#7f1d1d', fontSize: '13px', marginBottom: '1rem' }}>
            Copy this error and send it to the developer.
          </p>
          <pre style={{
            background: '#fff',
            border: '1px solid #fca5a5',
            borderRadius: '8px',
            padding: '1rem',
            fontSize: '11px',
            overflowX: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
          }}>
            {this.state.error?.toString()}
            {'\n\n'}
            {this.state.info?.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
